var map = {
	"./data/pt-BR/Countries.json": [
		40338,
		102
	],
	"./data/pt-BR/GAPageViews.json": [
		56219,
		443
	],
	"./data/pt-BR/articles.json": [
		28497
	],
	"./data/pt-BR/export-pathmap.json": [
		93234,
		3234
	],
	"./data/pt-BR/pgDataLayer.json": [
		15230,
		8639
	],
	"./data/pt-BR/products.json": [
		43314
	],
	"./data/pt-BR/seo.json": [
		55729,
		8639
	],
	"./data/pt-BR/url.json": [
		35269
	],
	"./static-data-source/pt-BR/articleAlgolia.json": [
		41532,
		102
	],
	"./static-data-source/pt-BR/articlePage/estudo-clinito-pantene-biotinamina-b3.json": [
		15386,
		5386
	],
	"./static-data-source/pt-BR/articlePage/pantene-e-bom-para-o-cabelo.json": [
		53583,
		3583
	],
	"./static-data-source/pt-BR/articlePage/pantene-perguntas-frequentes.json": [
		56449,
		6449
	],
	"./static-data-source/pt-BR/articlePage/pantenol-para-o-cabelo.json": [
		97878,
		7878
	],
	"./static-data-source/pt-BR/articlePage/quanta-queda-de-cabelo-e-normal.json": [
		23759,
		3759
	],
	"./static-data-source/pt-BR/bvReviews.json": [
		5652,
		5652
	],
	"./static-data-source/pt-BR/contentPage/colecoes_bambu-nutre-e-cresce.json": [
		10782,
		782
	],
	"./static-data-source/pt-BR/contentPage/colecoes_biotinamina-antiqueda-nutricao.json": [
		72352,
		9911
	],
	"./static-data-source/pt-BR/contentPage/colecoes_bond-repair-para-cabelos-danificados.json": [
		16524,
		6524
	],
	"./static-data-source/pt-BR/contentPage/colecoes_colageno-hidrata-resgata.json": [
		52275,
		4656
	],
	"./static-data-source/pt-BR/contentPage/colecoes_hidrata-e-resgata-com-colageno.json": [
		11826,
		1826
	],
	"./static-data-source/pt-BR/contentPage/colecoes_hidratacao.json": [
		94040,
		9911
	],
	"./static-data-source/pt-BR/contentPage/colecoes_liso-extremo.json": [
		80338,
		2530
	],
	"./static-data-source/pt-BR/contentPage/orientacoes-para-analise.json": [
		4693,
		4693
	],
	"./static-data-source/pt-BR/contentPage/termos-e-condicoes.json": [
		86216,
		9371
	],
	"./static-data-source/pt-BR/homePage/index.json": [
		47598,
		443
	],
	"./static-data-source/pt-BR/layout/index.json": [
		50080,
		80
	],
	"./static-data-source/pt-BR/productAlgolia.json": [
		71635,
		1635
	],
	"./static-data-source/pt-BR/productListPage/condicionador.json": [
		68952,
		8952
	],
	"./static-data-source/pt-BR/productListPage/creme-para-pentear.json": [
		34609,
		4609
	],
	"./static-data-source/pt-BR/productListPage/produtos.json": [
		51938,
		1938
	],
	"./static-data-source/pt-BR/productListPage/shampoo.json": [
		54923,
		4923
	],
	"./static-data-source/pt-BR/productListPage/tratamentos.json": [
		20978,
		978
	],
	"./static-data-source/pt-BR/productPage/biotinamina-antiqueda-nutricao.json": [
		32876,
		2876
	],
	"./static-data-source/pt-BR/productPage/colageno-hidrata-resgata.json": [
		55044,
		5044
	],
	"./static-data-source/pt-BR/productPage/condicionador-selador-molecular.json": [
		32202,
		2202
	],
	"./static-data-source/pt-BR/productPage/creme-para-pentear-cabelos-danificados.json": [
		50955,
		955
	],
	"./static-data-source/pt-BR/productPage/hidratacao.json": [
		20540,
		540
	],
	"./static-data-source/pt-BR/productPage/liso-extremo.json": [
		24622,
		4622
	],
	"./static-data-source/pt-BR/productPage/mascara-bambu-reparacao-para-cabelo-danificado.json": [
		64096,
		443
	],
	"./static-data-source/pt-BR/productPage/mascara-hidratante-colageno-hidrata-resgata.json": [
		90510,
		510
	],
	"./static-data-source/pt-BR/productPage/mascara-intensiva-molecular.json": [
		88257,
		8257
	],
	"./static-data-source/pt-BR/productPage/nutre-e-cresce.json": [
		52954,
		9371
	],
	"./static-data-source/pt-BR/productPage/protetor-termico-multibeneficios-spray.json": [
		76892,
		6892
	],
	"./static-data-source/pt-BR/productPage/queratina-preenche-blinda.json": [
		58652,
		8652
	],
	"./static-data-source/pt-BR/productPage/serum-pantene-forca-nutricao.json": [
		40554,
		554
	],
	"./static-data-source/pt-BR/productPage/shampoo-reparador-molecular-bond.json": [
		58283,
		8283
	],
	"./static-data-source/pt-BR/productPage/tonico-cabelo-biotinamina-antiqueda-nutricao.json": [
		40444,
		444
	],
	"./static-data-source/pt-BR/productPage/tratamento-leave-in-para-cabelo-ressecado.json": [
		66559,
		6559
	],
	"./static-data-source/pt-BR/siteMap/index.json": [
		12513,
		443
	],
	"./static-data-source/pt-BR/urlBuilder.json": [
		68077,
		8077
	],
	"./utils/grs/config.json": [
		23276,
		443
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21015;
module.exports = webpackAsyncContext;